import React from "react"
import { Link } from "gatsby"

import { FaFacebookSquare, FaInstagram } from "react-icons/fa"

const Footer = ({ data }) => {
  return (
    <React.Fragment>
      <footer className="bg-dark py-5">
        <div className="container d-flex justify-content-between flex-column flex-md-row border-top pt-3 px-0">
          <div className="">
            <Link className="text-white" to="/">
              Ricardo Sawir
            </Link>
            <p className="text-muted">
              Copyright © {new Date().getFullYear().toString()} Ricardo Sawir.
              All rights reserved.
            </p>
          </div>
          <div className="d-flex justify-content-end flex-column ">
            <ul className="navbar-nav flex-column flex-md-row">
              {data.map(link => {
                return (
                  <li className="nav-item mr-3 mr-md-0 ml-md-3" key={link.id}>
                    <Link className="nav-link text-white" to={link.link}>
                      {link.name}
                    </Link>
                  </li>
                )
              })}
            </ul>
            <div className="text-white justify-content-start justify-content-md-end d-flex mt-3">
              <FaFacebookSquare />
              <FaInstagram />
            </div>
          </div>
        </div>
        <div className="container text-left text-md-center px-0 mt-3">
          <p className="text-muted">
            Built with{" "}
            <a
              className="text-muted"
              rel="noopener noreferrer"
              target="_blank"
              href="https://sawirstudio.com/"
            >
              Sawir Studio
            </a>
          </p>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer
